import React from 'react';
import GamesLiveOpsTemplate from '../components/Connect/LiveOps/index';

function index() {
  return <GamesLiveOpsTemplate />;
}
export default index;
